import Vue from 'vue'

const state = {
  popup_open: false,
  popup_marine_open: false,
  import_marine_gi_portal: {
    is_from_marine_gi_portal: true,
    name: '',
    username: '',
    wkt: '',
    alternate: ''
  },
  import_data_baseline: {
    is_from_marine_gi_portal: false,
    name: '',
    username: '',
    shp: null
  },
  edit_data_baseline: [],
  loading: false
}

const getters = {}

const actions = {
  set_ref_baseline: async ({ state, dispatch }, result) => {
    state.loading = true
    await Vue.axios?.post('set/ref/baseline', result, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((response) => {
        if (response.data.success !== true) return
        Vue.$toast.success(response.data.message)
        state.popup_open = false
        state.loading = false
        dispatch('tabBaseline/set_loading', null, { root: true })
      })
      .catch((error) => {
        state.loading = false
        if (error?.data?.success === false) Vue.$toast.error(error.data.message)
      })
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
